export default __webpack_public_path__ + "static/media/gallery-img1.9ac373fc.jpg";